/**
 * @param {import('@/types/api').Appointment} appointment
 */
export function canCheckInAppointment(appointment) {
  return ['scheduled', 'confirmed'].includes(appointment.status)
}

/**
 * @param {import('@/types/api').Appointment} appointment
 */
export function canStartAppointmentInChair(appointment) {
  return ['scheduled', 'confirmed', 'checked_in'].includes(appointment.status)
}

/**
 * @param {import('@/types/api').Appointment} appointment
 * @param {string} dateIso YYYY-MM-DD
 */
export function appointmentOnDate(appointment, dateIso) {
  if (!appointment.starts_at) {
    return false
  }

  return appointment.starts_at.slice(0, 10) === dateIso
}

/**
 * @param {import('@/types/api').Appointment[]} appointments
 * @param {string} dateIso
 */
export function checkInArrivalsForDate(appointments, dateIso) {
  return appointments
    .filter(
      (appointment) =>
        appointmentOnDate(appointment, dateIso) &&
        (canCheckInAppointment(appointment) || canStartAppointmentInChair(appointment)),
    )
    .sort((left, right) => left.starts_at.localeCompare(right.starts_at))
}

/**
 * @param {import('@/types/api').Appointment} appointment
 */
export function defaultChairIdForAppointment(appointment) {
  return (
    appointment.chair?.id ??
    appointment.chair_id ??
    appointment.services?.find((line) => line.chair_id)?.chair_id ??
    ''
  )
}

/**
 * @param {string} startsAt
 */
export function formatArrivalTime(startsAt) {
  if (!startsAt) {
    return '—'
  }

  const date = new Date(startsAt)
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
}

/**
 * @param {string} status
 */
export function checkInStatusLabel(status) {
  switch (status) {
    case 'checked_in':
      return 'Checked in'
    case 'confirmed':
      return 'Confirmed'
    case 'scheduled':
      return 'Scheduled'
    default:
      return status.replaceAll('_', ' ')
  }
}
